import type { TabsDefinition } from '@/src/experiences/tabs'
import { CardBenefitsOutlined } from '../icons'

export const CardBenefitsTab = {
  'card-benefits': {
    name: 'card-benefits',
    title: 'Benefits',
    Icon: CardBenefitsOutlined,
    href: `/main/(tabs)/card-benefits`,
    options: {
      tabBarButton: () => null,
      tabBarItemStyle: {
        position: 'absolute',
        width: 0,
        height: 0,
        left: -1000,
      },
    },
  },
} as const satisfies TabsDefinition
